
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2025-07-26-r3f-scroll-offset-to-canvas",
      function () {
        return require("private-next-pages/blogs/2025-07-26-r3f-scroll-offset-to-canvas/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2025-07-26-r3f-scroll-offset-to-canvas"])
      });
    }
  